export default "__VITE_ASSET__BQYOliy$__"